import { Api } from "../../../listsSettings/api";

export const allItems: string = `/${Api.InternalName}/_lists/${Api.Lists.Users.InternalName}/_pages/all_items`;
export const newForm: string = `/${Api.InternalName}/_lists/${Api.Lists.Users.InternalName}/_pages/new`;
export const dispForm: string = `/${Api.InternalName}/_lists/${Api.Lists.Users.InternalName}/_pages/disp`;
export const editForm: string = `/${Api.InternalName}/_lists/${Api.Lists.Users.InternalName}/_pages/edit`;
